"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=InvalidStudent.js.map